import { useNavigate } from "react-router-dom";
import { Shield, Lock, MapPin } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import heroMockup from "@/assets/hero-phone-mockup.png";



const Hero = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <section className="relative min-h-[540px] flex items-center overflow-hidden">
      {/* Animated gradient background — same vibe as Categories card hover */}
      <div className="absolute inset-0 bg-sky-50" />
      <div className="absolute inset-0 bg-gradient-to-b from-blue-500/40 via-purple-500/15 to-transparent" />
      <div className="container relative z-10 px-6 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left side - Text + CTA */}
          <div className="max-w-xl lg:max-w-lg xl:max-w-xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight tracking-tight text-slate-900">
              Rent Anything. Earn From What You Own.
            </h1>
            <p className="text-lg md:text-xl mb-8 leading-relaxed text-slate-900">
              Cameras, tools, electronics, and more — rent from people near you.
            </p>

            <Button
              size="lg"
              className="h-14 px-10 rounded-xl text-lg font-semibold bg-[#e9dcf5] text-slate-900 hover:bg-[#dccff0] shadow-md hover:shadow-lg transition-all"
              onClick={() => navigate('/browse')}
            >
              {t("browseItems")}
            </Button>

            {/* Trust strip */}
            <div className="mt-10 rounded-2xl bg-white/70 backdrop-blur-md border border-white/60 shadow-sm px-5 py-4 flex flex-col sm:flex-row gap-5 sm:gap-6">
              {[
                { Icon: Shield, title: "Verified owners", sub: "Trusted community", bg: "bg-primary/10" },
                { Icon: Lock, title: "Secure payments", sub: "Safe & protected", bg: "bg-emerald-500/10" },
                { Icon: MapPin, title: "Pickup nearby", sub: "Convenient & local", bg: "bg-primary/10" },
              ].map(({ Icon, title, sub, bg }) => (
                <div key={title} className="flex items-center gap-2.5">
                  <span className={`w-9 h-9 rounded-xl ${bg} flex items-center justify-center flex-shrink-0`}>
                    <Icon className="w-4 h-4 text-primary" />
                  </span>
                  <span className="leading-tight whitespace-nowrap">
                    <span className="block text-[13px] font-semibold text-slate-900">{title}</span>
                    <span className="block text-[13px] text-slate-600">{sub}</span>
                  </span>
                </div>
              ))}

            </div>
          </div>


          {/* Right side - App mockup */}
          <div className="hidden lg:flex items-center justify-center">
            <img
              src={heroMockup}
              alt="Rentify app showing rental items on a map with Cameras, Bikes and Camping categories"
              width={1176}
              height={956}
              className="w-full max-w-[560px] h-auto object-contain drop-shadow-xl"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
